"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTip = exports.FormItem = exports.FormFooter = exports.Form = exports.normalizeFormLayout = exports.useFormFooterCtx = void 0;
var defs_1 = require("./defs");
Object.defineProperty(exports, "useFormFooterCtx", { enumerable: true, get: function () { return defs_1.useFooterCtx; } });
Object.defineProperty(exports, "normalizeFormLayout", { enumerable: true, get: function () { return defs_1.normalizeLayout; } });
var Form_1 = require("./Form");
Object.defineProperty(exports, "Form", { enumerable: true, get: function () { return __importDefault(Form_1).default; } });
Object.defineProperty(exports, "FormFooter", { enumerable: true, get: function () { return Form_1.Footer; } });
var FormItem_1 = require("./FormItem");
Object.defineProperty(exports, "FormItem", { enumerable: true, get: function () { return __importDefault(FormItem_1).default; } });
Object.defineProperty(exports, "FormTip", { enumerable: true, get: function () { return FormItem_1.Tip; } });
//# sourceMappingURL=index.js.map